const zh_CN = {
    info: {
        title: "轴伊按钮",
        info: "信息",
        null: "空",
        audioStaff: "音频剪辑: ",
        footerSubmit: "有想加进来的音声？从投稿页发给我。",
        toGithub: "本站源码在 GitHub",
        notOfficial: "本站为爱好者作品，和VirtuaReal/Nijisanji (Anycolor) 官方没有关联",
        overlapTips: "重叠播放无法暂停，而且会创建大量线程，玩够了最好刷新一下",
        loopTips: "会一直循环播放你选中的那一条，反正它不会自己停下来，所以另外两个功能就用不上了，关掉循环才能再用",
        clipInfo: "音声信息",
        clipSource: "来源",
        clipDate: "日期",
        clipDuration: "时间点",
        clipOriginal: "原视频",
        clipSubmitter: "投稿人",
        clipJump: "去原视频这一刻",
        clipType: { label: "类型", video: "视频", stream: "直播切片" },
        yt_channel: "轴伊的频道",
        lang: "语言: "
    },
    action: {
        toggleNavbar: "切换导航栏",
        close: "关闭",
        copy: "复制",
        control: "操作控制",
        stopvoice: "停止",
        randomplay: "帮我选一个",
        overlap: "允许声音重叠",
        autoplay: "播放不要停下来",
        playing: "正在播放：",
        noplay: "暂无播放",
        loop: "单曲循环",
        details: "显示详情",
        volume: "音量: "
    },
    lang: {
        'zh-CN': "简体中文",
        'en-US': "English",
        'ja-JP': "日本語"
    }
}
export default zh_CN;
